
import "./pageHeading.css";
export const PageHeading = ({ title }) => {
  return (
    <header className="p-3 text-center">
      <h1>{title}</h1>
    </header>
  );
};
